/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {defaultsDeep} from 'lodash';

import {AbstractService} from '@amblique/base/shared/services/abstract-service';

/**
 * OCAPI Shop Service
 */
export class ShopService extends AbstractService {
  /**
   * @returns {string}
   */
  static get name() {
    return 'ShopService';
  }

  /**
   * @returns {object}
   */
  static get profile() {
    return defaultsDeep({
      baseUrl: '{origin}/mobify/proxy/ocapi/s/{site.id}/dw/shop/{shopAPI.version}',
      dynamicProperties: ['baseUrl', 'options.headers.x-dw-client-id'],
      options: {
        headers: {
          'x-dw-client-id': '{shopAPI.clientId}',
        },
      },
    }, super.profile);
  }

  /**
   * @returns {string[]}
   */
  static get variables() {
    return ['origin', 'site', 'shopAPI'];
  }

  /**
   * Gets a single content asset
   *
   * @param {string}      id
   * @param {RequestInit} [options]
   *
   * @returns {Promise<object>}
   */
  getContent(id, options) {
    return this.get(`content/${id}`, options);
  }

  /**
   * Gets multiple content assets
   *
   * @param {string|string[]} ids
   * @param {RequestInit}     [options]
   *
   * @returns {Promise<{count: number, total: number, data: object[]}>}
   */
  getContents(ids, options) {
    return this.get(`content/(${ids.join(',')})`, options);
  }
}
